export const STAGING_APP_HOSTNAME = 'staging.app.asaph.io';

export const isStagingAsaphHost = (): boolean => {
	if (typeof window === 'undefined') {
		return false;
	}
	const { hostname } = window.location;
	return (
		hostname === STAGING_APP_HOSTNAME ||
		(hostname.includes('staging') && hostname.endsWith('.asaph.io'))
	);
};
